import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Company } from 'core/models/company';

const initialState = null as Company | null;

const companySlice = createSlice({
	name: 'company',
	initialState: initialState,
	reducers: {
		setCompany: (_, action: PayloadAction<Company>) => action.payload,
		clearCompany: () => null,
		updateCompany: (state, action: PayloadAction<Partial<Company>>) => {
			if (state) {
				Object.assign(state, action.payload);
			}
		},
		subtractPoints: (state, action: PayloadAction<number>) => {
			if (state) {
				state.point_wallet -= action.payload;
			}
		},
	},
});

export const { setCompany, clearCompany, updateCompany, subtractPoints } = companySlice.actions;
export default companySlice.reducer;
